import { FormControl, Grid } from '@forgeglobal/design-framework';
import { useStyles } from './DocumentsTableHeader.style';

export interface Props {
  items: React.ReactNode[];
}

const DocumentsTableHeader = ({ items }: Props) => {
  const classes = useStyles();

  const renderItems = items.map((item, index) => (
    <FormControl className={classes.input} key={index}>
      {item}
    </FormControl>
  ));

  return (
    <Grid item className={classes.inputWrapper}>
      {renderItems}
    </Grid>
  );
};

export default DocumentsTableHeader;
